import { useCallback, useEffect } from 'react'
import { StatusType, useFetch } from '../../hooks'

interface TranslationDataUpdaterProps<FetchDataType> {
  dataUpdateFn: (updatedData: FetchDataType) => void
  query: string
}

export const TranslationDataUpdater = <FetchDataType,>({
  dataUpdateFn,
  query
}: TranslationDataUpdaterProps<FetchDataType>) => {
  const { fetchState } = useFetch<FetchDataType>({
    query
  })

  const updateTranslationData = useCallback(
    (updatedData: FetchDataType) => {
      dataUpdateFn(updatedData)
    },
    [dataUpdateFn]
  )

  useEffect(() => {
    if (fetchState.status === StatusType.FETCHED) {
      const updatedData = fetchState.data
      updateTranslationData(updatedData)
    }
  }, [fetchState, updateTranslationData])

  return null
}
